import { createFileRoute } from '@tanstack/react-router';

import { AuthenticationErrorPage } from 'component/view/Redirects/AuthenticationErrorPage';

export const Route = createFileRoute('/n/authentication-error-message')({
  component: AuthenticationErrorPage,
});
